import React, { useState, useEffect, useRef } from "react";
import { Calendar } from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import moment from "jalali-moment";
import { toast } from "react-toastify";

export default function DateFilter({ onFilter = () => { },
buttonText = { default: "فیلتر تاریخ 📅", active: "حذف فیلتر" } 
 }) {
    const [isOpen, setIsOpen] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [activeField, setActiveField] = useState(null);
    const [addDateFilter, setAddDateFilter] = useState(false);
    const calendarRef = useRef(null);
    const filterRef = useRef(null);
    // مدیریت کلیک بیرون از تقویم و دراپ‌دان
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                calendarRef.current && !calendarRef.current.contains(event.target) &&
                filterRef.current && !filterRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        }

        if (isOpen) {
            document.addEventListener("click", handleClickOutside);
        }

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [isOpen]);

    const handleDateChange = (date) => {
        if (activeField === "from") {
            setFromDate(date);
        } else if (activeField === "to") {
            setToDate(date);
        }
        setActiveField(null);
    };

    const handleCalendarClick = (event) => {
        event.stopPropagation();
    };

    const applyFilter = () => {
        if (!fromDate || !toDate) {
            toast.error("لطفاً تاریخ شروع را قبل از تاریخ پایان انتخاب کنید.");
            return;
        }

        const from = moment(`${fromDate.year}/${fromDate.month}/${fromDate.day}`, "jYYYY/jM/jD");
        const to = moment(`${toDate.year}/${toDate.month}/${toDate.day}`, "jYYYY/jM/jD");

        if (from.isAfter(to)) {
            toast.error("تاریخ 'از' نمی‌تواند بعد از تاریخ 'تا' باشد.");
            return;
        }
        if (fromDate || toDate) {
            onFilter(fromDate, toDate);
            setAddDateFilter(true);
        }
    };

    const clearFilter = () => {
        setFromDate(null);
        setToDate(null);
        setAddDateFilter(false);
        onFilter(null, null);;
        setIsOpen(false)
    };

    const formatDate = (date) => {
        if (!date) return "";
        return `${date.year}/${date.month < 10 ? `0${date.month}` : date.month}/${date.day < 10 ? `0${date.day}` : date.day}`;
    };

    return (
        <div className="relative inline-block text-right px-1" ref={calendarRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`${addDateFilter?"bg-red-500" :"bg-blue-500"} text-white px-4 py-2 rounded border w-[120px]`}
            >
                {addDateFilter ? "حذف فیلتر" : " فیلتر تاریخ 📅"}
            </button>

            {isOpen && (
                <div className="absolute left-12 mt-2 bg-white border rounded-lg shadow-lg p-4 w-64 z-50">
                    <div className="mb-3">
                        <label className="block text-gray-700">از تاریخ:</label>
                        <input
                            type="text"
                            readOnly
                            onClick={() => setActiveField("from")}
                            value={fromDate ? formatDate(fromDate) : ""}
                            className="w-full px-3 py-2 border rounded cursor-pointer text-center"
                            disabled={addDateFilter}
                        />
                    </div>

                    <div className="mb-3">
                        <label className="block text-gray-700">تا تاریخ:</label>
                        <input
                            type="text"
                            readOnly
                            onClick={() => setActiveField("to")}
                            value={toDate ? formatDate(toDate) : ""}
                            className="w-full px-3 py-2 border rounded cursor-pointer text-center"
                            disabled={addDateFilter}
                        />
                    </div>

                    {activeField && (
                        <div className="absolute top-0 left-0 right-0 mt-20" onClick={handleCalendarClick}>
                            <Calendar
                                value={activeField === "from" ? fromDate : toDate}
                                onChange={handleDateChange}
                                shouldHighlightWeekends
                                locale="fa"
                            />
                        </div>
                    )}

                    <button
                        ref={filterRef}
                        onClick={addDateFilter ? clearFilter : applyFilter}
                        className={`w-full ${addDateFilter?"bg-red-500":"bg-blue-500"} bg-green-500 text-white px-4 py-2 mt-3 rounded`}
                    >
                        {/* {addDateFilter ? "حذف فیلتر" : "اعمال فیلتر"} */}
                        {addDateFilter ? buttonText.active : buttonText.default}
                    </button>
                </div>
            )}
        </div>
    );
}
